import React, { createContext, useContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [userInfo, setUserInfo] = useState({});
  const [initialLoader, setInitialLoader] = useState(true);
  const [opacity, setOpacity] = useState(1);
  const [contentOpacity, setContentOpacity] = useState(0);

  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    const loaderTimer = setTimeout(() => {
      setOpacity(0);
      setContentOpacity(1);
      setTimeout(() => { setInitialLoader(false); }, 200);
    }, 400);
    return () => clearTimeout(loaderTimer);
  }, []);

  const getUserDetails = async () => {
    let data = await localStorage.getItem("userInfo");
    data = JSON.parse(data);
    if (data?.refreshToken == undefined) {
      setUserInfo({});
    } else {
      setUserInfo(data);
    }
  };

  const logout = async () => {
    await localStorage.clear();
    setUserInfo({});
  };

  const state = {
    userInfo,
    setUserInfo,
    logout,
    initialLoader,
    opacity,
    contentOpacity
  };

  return (
    <AuthContext.Provider value={state}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
